import { useState } from 'react';
import { ActionWithPopoverContext } from './ActionWithPopoverContext';

export const ActionWithPopoverProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const value = useState<HTMLButtonElement | null>(null);
  return (
    <ActionWithPopoverContext.Provider value={value}>{children}</ActionWithPopoverContext.Provider>
  );
};
